import {btn, comp, Component, router, tbar} from "@intermesh/goui";
import {CurrentSection} from "./services/CurrentSection.js";
import {ServerApi} from "./util/ServerApi.js";
import {t} from "./util/Translate.js";
export class SectionInfo extends Component {

	private titleCmp: Component;
	private imgCmp: Component;
	private sectionInfoCmp: Component;
	constructor() {
		super("section");
		this.itemId = "section-info";
		this.id = "section-info";
		this.cls = "ifw-card";

		// if(!PortalConfig.sectionId) {
		// 	router.goto("");
		// }

		const pc = JSON.parse(localStorage.getItem("portalConfig")!);

		this.titleCmp = comp({tagName: "h2", cls: "ifw-title", text: ""});

		this.imgCmp = comp({tagName: "img", height: 200});

		this.sectionInfoCmp = comp({tagName: "p", html: "", hidden: true});

		this.items.add(
			comp({cls: "vbox pad"}, this.imgCmp, this.titleCmp, this.sectionInfoCmp),
			tbar({cls: "ifw-bbar"},
				btn({text: t("Back"), handler: (_btn) => {
						if(!pc.sectionId) {
							router.goto("register");
						} else {
							router.goto("section-selection");
						}
					}}),
				"->",
					btn({text: t("Continue"), route: "course-selection"})
		));

		this.on("render", async () => {
			const cs = await CurrentSection.readIf(String(pc.sectionId)!);

			const sectionLanguage = cs.languages.find((item: any)=> {
				return item.languageId === parseInt(sessionStorage.getItem("languageId")!);
			})
			this.titleCmp.text = sectionLanguage.infoPageTitle || cs.name;
			if(sectionLanguage.infoPageHtml) {
				this.sectionInfoCmp.html = sectionLanguage.infoPageHtml;
				this.sectionInfoCmp.show();
			}
			this.imgCmp.attr = {
				src: ServerApi.thumbUrl(cs.image, 200, 800, true),
				title: cs.name
			}
		});

	}
}